import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { reactive, onMounted, watch, ref, unref } from 'vue';
import { useRouter } from 'vue-router';
import { ElButton } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { GetWorkItemsApi } from '@/apis/tasks/task.api';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { WorkItem } from '@/apis/tasks/task.type';
import { useLocales } from '@/hooks/useLocales';

import AgreeDialog from './components/auditDialog.vue';
import RejectDialog from './components/rejectDialog.vue';
import TransferDialog from './components/transferDialog.vue';

import StampApplyDialog from './components/stampApplyDialog.vue';
import StampSureDialog from './components/stampSureDialog.vue';
import SignFileDialog from './components/signFile.vue';

import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  emits: ['uploadTotal'],
  setup(__props, { emit: $emits }) {

const { t } = useLocales();
const agreeDialogRef = ref<InstanceType<typeof AgreeDialog>>();
const rejectDialogRef = ref<InstanceType<typeof RejectDialog>>();
const transferDialogRef = ref<InstanceType<typeof TransferDialog>>();

const stampApplyRef = ref<InstanceType<typeof StampApplyDialog>>();
const stampSureRef = ref<InstanceType<typeof StampSureDialog>>();
const signFileRef = ref<InstanceType<typeof SignFileDialog>>();


const { push } = useRouter();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<WorkItem>({
	getListApi: GetWorkItemsApi,
	response: { data: 'data', total: 'total' },
});

const state = reactive({
	search: { Work_type: 1 } as any,
	paged: { current: 1, page_size: 20 },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'contract_no', label: t('contract.no', '合同编号'), columnWidth: '120' },
	{ field: 'contract_name', label: t('contract.name', '合同名称'), columnWidth: '200' },
	{ field: 'mainstay_name', label: t('contractList.table.ourParty', '我方主体'), columnWidth: '200' },
	{ field: 'plan_b_name', label: t('contractList.table.counterpart', '相对方'), columnWidth: '200' },
	{ field: 'amount', label: t('contractList.table.totalAmount', '合同总价'), columnWidth: '100', align: 'right' },
	{ field: 'node_name', label: t('workflow.node', '流程节点'), columnWidth: '80', align: 'center' },
	{ field: 'work_status_desc', label: t('workflow.actionType', '动作类型'), columnWidth: '80', align: 'center' },
	{ field: 'action_date', label: t('workflow.approvalTime', '审批时间'), columnWidth: '120', align: 'center' },
	{ field: 'remark', label: t('title.opinion', '审批意见') },
	{ field: 'action', width: '200', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

/* 私有的方法 */
const actions = {
	/* 数据预览 */
	preview: (row: any) => {
		push({
			path: `/contracts/previews`,
			query: {
				contractId: `${row.contract_id}`,
				nodeId: `${row.node_id}`,
			},
		});
	},

	/* 批核 */
	audit: (row: any) => {
		/* 审批 */
		if (row.status == 2) {
			unref(agreeDialogRef)?.showDialog(row);
		}

		/* 用印申请 */
		if (row.status == 3) {
			unref(stampApplyRef)?.showDialog(row);
		}

		/* 用印确认 */
		if (row.status == 10) {
			unref(stampSureRef)?.showDialog(row);
		}

		/* 上传签章文件 */
		if (row.status == 9) {
			unref(signFileRef)?.showNotify(row);
		}
	},
	/* 批核退回 */
	reject: (row: any) => {
		unref(rejectDialogRef)?.showDialog(row);
	},
	/* 移交 */
	transfer: (row: any) => {
		unref(transferDialogRef)?.showDialog(row);
	},
	reSetSearch: () => {
		state.search = { Work_type: 1 };
		methods.resetParams(state.search);
	},
	onSearch: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
};

onMounted(() => {
	tableObject.pageSize = 20;
	actions.onSearch();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(state).search,
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contract.no', '合同编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.ct_no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.ct_no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contract.name', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.ct_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.ct_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('workflow.taskType', '任务类型')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(state).search.Work_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).search.Work_type) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (actions.onSearch()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('title.myWork', '待办')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('workflow.completed', '已办')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      icon: "Search",
                      type: "primary",
                      onClick: actions.onSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          action_date: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.action_date ? _unref(moment)(row.action_date).format('YYYY-MM-DD HH:mm') : '--'), 1)
          ]),
          amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amount.toLocaleString('zh')), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_unref(ElButton), {
              size: "small",
              type: "primary",
              link: "",
              onClick: ($event: any) => (actions.preview(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.preview', '详细')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (_unref(state).search.Work_type == 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(ElButton), {
                    size: "small",
                    type: "warning",
                    link: "",
                    onClick: ($event: any) => (actions.transfer(row))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('workflow.transfer', '移交')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_unref(ElButton), {
                    size: "small",
                    type: "success",
                    link: "",
                    onClick: ($event: any) => (actions.audit(row))
                  }, {
                    default: _withCtx(() => [
                      (row.status == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(t)('buttons.audit', '审批')), 1))
                        : _createCommentVNode("", true),
                      (row.status == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)('contractList.form.stampApply', '用印申请')), 1))
                        : _createCommentVNode("", true),
                      (row.status == 10)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('contractList.form.stampConfirm', '用印确认')), 1))
                        : _createCommentVNode("", true),
                      (row.status == 9)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('contractList.form.archive', '合同入档')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_unref(ElButton), {
                    size: "small",
                    type: "danger",
                    link: "",
                    onClick: ($event: any) => (actions.reject(row))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('buttons.withdraw', '退回')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(AgreeDialog, {
      ref_key: "agreeDialogRef",
      ref: agreeDialogRef,
      onRefresh: actions.onSearch
    }, null, 8, ["onRefresh"]),
    _createVNode(RejectDialog, {
      ref_key: "rejectDialogRef",
      ref: rejectDialogRef,
      onRefresh: actions.onSearch
    }, null, 8, ["onRefresh"]),
    _createVNode(TransferDialog, {
      ref_key: "transferDialogRef",
      ref: transferDialogRef,
      onRefresh: actions.onSearch
    }, null, 8, ["onRefresh"]),
    _createVNode(StampApplyDialog, {
      ref_key: "stampApplyRef",
      ref: stampApplyRef,
      onRefresh: actions.onSearch
    }, null, 8, ["onRefresh"]),
    _createVNode(StampSureDialog, {
      ref_key: "stampSureRef",
      ref: stampSureRef,
      onRefresh: actions.onSearch
    }, null, 8, ["onRefresh"]),
    _createVNode(SignFileDialog, {
      ref_key: "signFileRef",
      ref: signFileRef,
      onRefresh: actions.onSearch
    }, null, 8, ["onRefresh"])
  ], 64))
}
}

})